import React from "react";
import { X } from "lucide-react";
import { FilterSelect, FilterSelectItem } from "@/components/ui/filter-select";

const TYPE_ITEMS = [
  { value: 'all', label: 'All Types' },
  { value: 'validation', label: 'Validation' },
  { value: 'transformation', label: 'Transformation' },
  { value: 'normalization', label: 'Normalization' },
  { value: 'enrichment', label: 'Enrichment' },
];

const LANG_ITEMS = [
  { value: 'all', label: 'All Languages' },
  { value: 'javascript', label: 'JavaScript' },
  { value: 'python', label: 'Python' },
  { value: 'sql', label: 'SQL' },
  { value: 'tiva_endpoint', label: 'Tiva Endpoint' },
];

const STATUS_ITEMS = [
  { value: 'all', label: 'All Status' },
  { value: 'Active', label: 'Active' },
  { value: 'Draft', label: 'Draft' },
  { value: 'Deprecated', label: 'Deprecated' },
];

function renderItems(items) {
  return items.map(item => (
    <FilterSelectItem key={item.value} value={item.value}>{item.label}</FilterSelectItem>
  ));
}

export default function ProcessingRuleFilters({ filters, onFiltersChange }) {
  const handleChange = (key, value) => onFiltersChange({ ...filters, [key]: value });
  const clearFilters = () => onFiltersChange({ rule_type: 'all', rule_language: 'all', status: 'all' });
  const hasActiveFilters = Object.values(filters).some(v => v !== 'all');

  return (
    <div className="flex flex-wrap items-center gap-3 shrink-0 max-w-full">
      <FilterSelect value={filters.rule_type} onValueChange={(v) => handleChange('rule_type', v)}>
        {renderItems(TYPE_ITEMS)}
      </FilterSelect>
      <FilterSelect value={filters.rule_language} onValueChange={(v) => handleChange('rule_language', v)}>
        {renderItems(LANG_ITEMS)}
      </FilterSelect>
      <FilterSelect value={filters.status} onValueChange={(v) => handleChange('status', v)}>
        {renderItems(STATUS_ITEMS)}
      </FilterSelect>
      {hasActiveFilters && (
        <button
          onClick={clearFilters}
          className="flex items-center gap-1 h-9 px-3 rounded-[5px] border-2 border-nav-active text-nav-active text-sm cursor-pointer bg-card-bg hover:border-nav-active-hover hover:text-nav-active-hover transition-colors"
        >
          <X size={14} />
          Clear
        </button>
      )}
    </div>
  );
}
